import INTERNAL_LINKS from "./InternalLinks";

export default [
  {
    text: "Community",
    url: "/",
  },
  {
    text: "Resources",
    url: "/",
  },
  {
    text: "2021 Global conference",
    url: "/",
  },
  {
    text: "Become a member",
    url: INTERNAL_LINKS.JOIN,
  },
];
